import React, { useContext } from 'react';
import {
	fontFamily,
	textAlign,
	lineHeight,
	fontWeight,
	fontSize,
	letterSpacing,
	color,
	space,
	fontStyle,
	flexWrap,
	width,
} from 'styled-system';
import styled from 'styled-components';
import { ThemeContext } from 'styled-components';

const Content = styled.div`
    ${fontSize}
    ${fontFamily}
    ${textAlign}
    ${lineHeight}
    ${fontWeight}
    ${letterSpacing}
    ${color}
    ${space}
    ${fontStyle}
    ${flexWrap}
    ${width}
`;

const Container = ({ className, ...restProps }) => {
	const theme = useContext(ThemeContext);
	return (
		<Content
			className={`fn-container container ${className || ''}`}
			{...theme.container}
			{...restProps}
		/>
	);
};

export default Container;
